module.exports = __webpack_public_path__ + "files/4dde987ba3b870b95d6a0b3cee5f1e81.png";